"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const lodash_1 = __importDefault(require("lodash"));
const expressions_ui_1 = require("@mwater/expressions-ui");
const ItemsHtmlConverter_1 = __importDefault(require("./ItemsHtmlConverter"));
const react_float_affixed_1 = __importDefault(require("react-float-affixed"));
const FontColorPaletteItem_1 = __importDefault(require("./FontColorPaletteItem"));
const DropdownPaletteItem_1 = __importDefault(require("./DropdownPaletteItem"));
class RichTextComponent extends react_1.default.Component {
    static defaultProps = {
        includeHeadings: true,
        items: [],
        itemsHtmlConverter: new ItemsHtmlConverter_1.default(),
    };
    entireComponent = null;
    contentEditable = null;
    paletteComponent = null;
    /** Number of changes in progress. Used with beginChanges and endChanges
     * to prevent onChange being called during a change */
    changesInProgress = 0;
    constructor(props) {
        super(props);
        this.state = {
            focused: false,
        };
    }
    handleClick = (ev) => {
        // If click is in component or in palette component, ignore, otherwise remove focus
        if (!this.entireComponent.contains(ev.target) &&
            (!this.paletteComponent || !this.paletteComponent.contains(ev.target))) {
            return this.setState({ focused: false });
        }
    };
    // Paste HTML in
    pasteHTML(html) {
        this.contentEditable.pasteHTML(html);
    }
    focus() {
        this.contentEditable.focus();
    }
    beginChanges() {
        this.changesInProgress++;
    }
    endChanges() {
        this.changesInProgress--;
        if (this.changesInProgress === 0) {
            this.handleChange(this.contentEditable.getEditor());
        }
    }
    handleInsertExpr = (item) => {
        const html = '<div data-embed="' + lodash_1.default.escape(JSON.stringify(item)) + '"></div>';
        this.contentEditable.pasteHTML(html);
    };
    handleSetFontColor = (color) => {
        // Requires a selection
        const html = this.contentEditable.getSelectedHTML();
        if (!html) {
            return alert(T `Please select text first to set color`);
        }
        this.handleCommand("foreColor", color);
    };
    handleSetFontSize = (tag, size) => {
        this.beginChanges();
        try {
            this.handleCommand("formatBlock", `<${tag}>`);
            const selection = window.getSelection();
            if (!selection || !selection.rangeCount)
                return;
            // Function to apply or remove font size
            const applyFontSize = (element) => {
                if (size === null) {
                    element.style.removeProperty("font-size");
                }
                else {
                    element.style.fontSize = size;
                }
            };
            // Get the start and end containers of the selection
            const range = selection.getRangeAt(0);
            let startNode = range.startContainer.nodeType === Node.TEXT_NODE ? range.startContainer.parentElement : range.startContainer.childNodes[range.startOffset];
            let endNode = range.endContainer.nodeType === Node.TEXT_NODE ? range.endContainer.parentElement : range.endContainer.childNodes[range.endOffset];
            // Find element that has parent with contentEditable
            while (startNode && !startNode.parentElement?.contentEditable) {
                startNode = startNode.parentElement;
            }
            while (endNode && !endNode.parentElement?.contentEditable) {
                endNode = endNode.parentElement;
            }
            if (!startNode || !endNode || startNode.nodeType !== Node.ELEMENT_NODE || endNode.nodeType !== Node.ELEMENT_NODE) {
                return;
            }
            // Get array of nodes between start and end
            const rootElements = [];
            let node = startNode;
            while (node !== null) {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    rootElements.push(node);
                }
                if (node === endNode) {
                    break;
                }
                node = node.nextSibling;
            }
            for (const element of rootElements) {
                applyFontSize(element);
            }
        }
        finally {
            this.endChanges();
        }
    };
    handleChange = (elem) => {
        if (this.changesInProgress > 0) {
            return;
        }
        const items = this.props.itemsHtmlConverter.convertElemToItems(elem);
        // Check if changed
        if (!lodash_1.default.isEqual(items, this.props.items)) {
            this.props.onItemsChange(items);
        }
        else {
            // Re-render as HTML may have been mangled and needs a round-trip
            this.forceUpdate();
        }
    };
    handleFocus = () => {
        this.setState({ focused: true });
    };
    handleBlur = () => {
        this.setState({ focused: false });
    };
    // Perform a command such as bold, underline, etc.
    handleCommand = (command, param, ev) => {
        // Don't lose focus
        ev?.preventDefault();
        // Use CSS for some commands
        if (["foreColor"].includes(command)) {
            document.execCommand("styleWithCSS", null, true);
            document.execCommand(command, false, param);
            document.execCommand("styleWithCSS", null, false);
        }
        else {
            document.execCommand(command, false, param);
        }
    };
    handleCreateLink = (ev) => {
        // Don't lose focus
        ev.preventDefault();
        // Ask for url
        const url = window.prompt(T `Enter URL to link to`);
        if (url) {
            document.execCommand("createLink", false, url);
        }
    };
    handleEditorClick = (ev) => {
        // Be sure focused
        if (!this.state.focused) {
            this.setState({ focused: true });
        }
        const target = ev.target;
        if (target.dataset?.embed || target.parentElement?.dataset?.embed) {
            const item = JSON.parse(target.dataset?.embed || target.parentElement?.dataset?.embed);
            if (item != null) {
                this.props.onItemClick?.(item);
            }
        }
    };
    createHtml() {
        return this.props.itemsHtmlConverter.convertItemsToHtml(this.props.items);
    }
    renderPalette() {
        // Determine current z-index to be able to float above it
        let zIndex = null;
        let elem = this.entireComponent;
        while (elem != null) {
            const elemZIndex = window.getComputedStyle(elem).zIndex;
            if (!isNaN(parseInt(elemZIndex))) {
                zIndex = parseInt(elemZIndex);
                break;
            }
            elem = elem.parentElement;
        }
        return (react_1.default.createElement(react_float_affixed_1.default, { style: { zIndex }, edges: "over,under,left,right", align: "center", render: this.renderPaletteContent }));
    }
    renderPaletteContent = (schemeName, { edges }) => {
        return (react_1.default.createElement("div", { key: "palette", className: "mwater-visualization-text-palette", ref: (c) => {
                this.paletteComponent = c;
            } },
            react_1.default.createElement("div", { key: "bold", className: "mwater-visualization-text-palette-item", onMouseDown: (ev) => this.handleCommand("bold", null, ev) },
                react_1.default.createElement("i", { className: "fas fa-bold" })),
            react_1.default.createElement("div", { key: "italic", className: "mwater-visualization-text-palette-item", onMouseDown: (ev) => this.handleCommand("italic", null, ev) },
                react_1.default.createElement("i", { className: "fas fa-italic" })),
            react_1.default.createElement("div", { key: "underline", className: "mwater-visualization-text-palette-item", onMouseDown: (ev) => this.handleCommand("underline", null, ev) },
                react_1.default.createElement("i", { className: "fas fa-underline" })),
            react_1.default.createElement(FontColorPaletteItem_1.default, { key: "foreColor", onSetColor: this.handleSetFontColor, position: schemeName === "over" ? "under" : "over" }),
            react_1.default.createElement("div", { key: "link", className: "mwater-visualization-text-palette-item", onMouseDown: (ev) => this.handleCreateLink(ev) },
                react_1.default.createElement("i", { className: "fas fa-link" })),
            react_1.default.createElement("div", { key: "removeFormat", className: "mwater-visualization-text-palette-item", onMouseDown: (ev) => this.handleCommand("removeFormat", null, ev), style: { paddingLeft: 5, paddingRight: 5 } },
                react_1.default.createElement("i", { className: "fas fa-remove-format" })),
            react_1.default.createElement(DropdownPaletteItem_1.default, { key: "justify", items: [
                    { label: react_1.default.createElement("span", null,
                            react_1.default.createElement("i", { className: "fas fa-align-left fa-fw" }),
                            " ",
                            T `Left`), value: "justifyLeft" },
                    { label: react_1.default.createElement("span", null,
                            react_1.default.createElement("i", { className: "fas fa-align-center fa-fw" }),
                            " ",
                            T `Center`), value: "justifyCenter" },
                    { label: react_1.default.createElement("span", null,
                            react_1.default.createElement("i", { className: "fas fa-align-right fa-fw" }),
                            " ",
                            T `Right`), value: "justifyRight" },
                    { label: react_1.default.createElement("span", null,
                            react_1.default.createElement("i", { className: "fas fa-align-justify fa-fw" }),
                            " ",
                            T `Justify`), value: "justifyFull" },
                ], onSelect: (value) => this.handleCommand(value, null), position: schemeName === "over" ? "under" : "over", label: react_1.default.createElement("i", { className: "fas fa-align-left" }) }),
            react_1.default.createElement("div", { key: "insertUnorderedList", className: "mwater-visualization-text-palette-item", onMouseDown: (ev) => this.handleCommand("insertUnorderedList", null, ev) },
                react_1.default.createElement("i", { className: "fas fa-list-ul" })),
            react_1.default.createElement("div", { key: "insertOrderedList", className: "mwater-visualization-text-palette-item", onMouseDown: (ev) => this.handleCommand("insertOrderedList", null, ev) },
                react_1.default.createElement("i", { className: "fas fa-list-ol" })),
            this.props.includeHeadings && [
                react_1.default.createElement(DropdownPaletteItem_1.default, { key: "paragraph", items: [
                        { label: T `Heading 1`, value: "h1" },
                        { label: T `Heading 2`, value: "h2" },
                        { label: T `Extra Small`, value: "xsmall" },
                        { label: T `Small`, value: "small" },
                        { label: T `Normal`, value: "normal" },
                        { label: T `Large`, value: "large" },
                        { label: T `Extra Large`, value: "xlarge" },
                        { label: T `6px`, value: "6px", more: true },
                        { label: T `7px`, value: "7px", more: true },
                        { label: T `8px`, value: "8px", more: true },
                        { label: T `9px`, value: "9px", more: true },
                        { label: T `10px`, value: "10px", more: true },
                        { label: T `11px`, value: "11px", more: true },
                        { label: T `12px`, value: "12px", more: true },
                        { label: T `14px`, value: "14px", more: true },
                        { label: T `16px`, value: "16px", more: true },
                        { label: T `18px`, value: "18px", more: true },
                        { label: T `20px`, value: "20px", more: true },
                        { label: T `22px`, value: "22px", more: true },
                        { label: T `24px`, value: "24px", more: true },
                        { label: T `30px`, value: "30px", more: true },
                        { label: T `36px`, value: "36px", more: true },
                    ], onSelect: (tag) => {
                        if (tag.startsWith("h")) {
                            this.handleSetFontSize(tag, null);
                        }
                        else if (tag === "normal") {
                            this.handleSetFontSize("div", null);
                        }
                        else if (tag === "large") {
                            this.handleSetFontSize("div", "120%");
                        }
                        else if (tag === "xlarge") {
                            this.handleSetFontSize("div", "150%");
                        }
                        else if (tag === "small") {
                            this.handleSetFontSize("div", "87.5%");
                        }
                        else if (tag === "xsmall") {
                            this.handleSetFontSize("div", "75%");
                        }
                        else {
                            this.handleSetFontSize("div", tag);
                        }
                    }, position: schemeName === "over" ? "under" : "over", label: react_1.default.createElement("i", { className: "fas fa-text-size" }) })
            ],
            this.props.extraPaletteButtons));
    };
    refContentEditable = (c) => {
        this.contentEditable = c;
    };
    renderHtml() {
        if (this.props.onItemsChange != null) {
            return (react_1.default.createElement("div", { key: "contents", style: this.props.style, className: this.props.className },
                react_1.default.createElement(expressions_ui_1.ContentEditableComponent, { ref: this.refContentEditable, style: { outline: "none" }, html: this.createHtml(), onChange: this.handleChange, onClick: this.handleEditorClick, onFocus: this.handleFocus, onBlur: this.handleBlur }),
                this.props.items?.[0] == null ? (react_1.default.createElement("div", { key: "placeholder", style: { color: "#DDD", position: "absolute", top: 0, left: 0, right: 0, pointerEvents: "none" } }, T `Click to Edit`)) : undefined));
        }
        else {
            return (react_1.default.createElement("div", { key: "contents", style: this.props.style, className: this.props.className, dangerouslySetInnerHTML: { __html: this.createHtml() } }));
        }
    }
    render() {
        return (react_1.default.createElement("div", { style: { position: "relative" }, ref: (c) => {
                this.entireComponent = c;
            } },
            this.renderHtml(),
            this.state.focused ? this.renderPalette() : undefined));
    }
}
exports.default = RichTextComponent;
